
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * UpdateType enum
 */
class UpdateType {
  /**
   * Initialize enum with a given value
   * @param {UpdateType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof UpdateType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!UpdateType}
   * @param {!UpdateType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof UpdateType)) {
      throw new TypeError('Instance of UpdateType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!UpdateType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!UpdateType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === UpdateType.CREATE.value) {
      return 'CREATE'
    }
    if (this.value === UpdateType.UPDATE.value) {
      return 'UPDATE'
    }
    if (this.value === UpdateType.DELETE.value) {
      return 'DELETE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!UpdateType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!UpdateType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!UpdateType} Created enum
   */
  static fromObject (other) {
    return new UpdateType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
UpdateType.CREATE = new UpdateType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
UpdateType.UPDATE = new UpdateType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
UpdateType.DELETE = new UpdateType(0 + 2)

export { UpdateType };

/**
 * Fast Binary Encoding UpdateType field model
 */
class FieldModelUpdateType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelUpdateType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelUpdateType}
   * @param {UpdateType=} defaults Default value, defaults is new UpdateType()
   * @returns {!UpdateType} Result value
   */
  get (defaults = new UpdateType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new UpdateType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelUpdateType}
   * @param {!UpdateType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelUpdateType };
